// Version (AIAgent_Versions) sub-entity client — restores the "Versions" Agent tab dropped in the
// 2026-08-19/20 AgentEditor.tsx refactor. Targets the real live backend
// (BizFirst.Ai.AiAgent.Api.Base's BaseVersionController), verified by reading the controller and
// entity directly.
//
// ROUTE DRIFT FOUND — the task's own briefing guessed `/api/v1/ai-agent/agent-versions`. Reading
// BaseVersionController.cs directly shows `[Route("api/v1/ai-agent/versions")]` — `/versions`,
// confirming the task's own hypothesis text (which said `/versions`) over the design doc's older
// `/agent-versions` guess.
//
// Fields — briefed shape confirmed but incomplete. Confirmed: ConfigSnapshot/InstructionSnapshot
// (JSON)/IsActive/DeployedOn/DeployedBy/UndeployedOn/PerformanceMetrics (JSON), and the
// description field is `Description` (not `VersionDescription`). NOT mentioned by the briefing:
// `VersionNumber` (required, string, 50) — the entity's actual version-label column, required on
// Version.cs. Documented in DevelopmentHistoryLog.md.
//
// STAYS READ-ONLY exactly as briefed — no create/update/delete methods here, matching the old
// dialog's own deliberate design and this phase's instruction. Only a list-by-agent read.
//
// getVersionsByAgent posts to `by-agent` (confirmed on BaseVersionController.cs), same
// `{ AgentID: { ID } }` shape as every other by-agent query in this package.

import { BaseAdminApiClient, type AdminApiConfig, type AdminApiResult } from './baseAdminApiClient';
import type { AgentVersionDTO } from '../types';

export class AgentVersionAdminApiClient extends BaseAdminApiClient {
  constructor(config: AdminApiConfig) {
    super(config);
  }

  async getVersionsByAgent(agentId: number): Promise<AdminApiResult<AgentVersionDTO[]>> {
    const result = await this.postQuery<AgentVersionDTO[]>('/api/v1/ai-agent/versions/by-agent', {
      AgentID: { ID: agentId },
      PageInfo: { PageNumber: 1, PageSize: 1000 },
    });
    return { ...result, data: Array.isArray(result.data) ? result.data : [] };
  }
}
